const myHeaders = new Headers();
  myHeaders.append("X-API-KEY", process.env.REACT_APP_INCLASS_KEY);

export const requestOptions = {
    method: 'GET',
    headers: myHeaders,
    redirect: 'follow'
};

